<template>
  <div class="w100 bg-w pt20 pb20 pl20 pr20"v-loading="loading" >
    <div style="height: calc(100vh - 120px); overflow: auto" >
      <div class="search-warp" style="text-align: right">
        <el-form :inline="true" label-width="100px" class="">
          <el-form-item label="通知类型:" >
            <el-select v-model="paramSearch.messageType" placeholder="请选择">
              <el-option
                      v-for="item in messageTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="initList">查询</el-button>
            <el-button type="primary"  @click="setAllread" v-if="getStatus">全部已读</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="message-warp">
        <div class="msg-item cl-f" v-for="(msg,index) in msglist">

          <div class="msg-left fl">
            {{msg.year&&(msg.year+'年')}}
          </div>
          <div class="msg-right fl">
            <span class="month" v-show="msg.yearMonth">{{msg.yearMonth&&(Number(msg.yearMonth.split('-')[1])+'月')}}</span>
            <i class="el-icon-location" v-if="index==0"></i>

            <div class="msg-content cl-f">
              <!--<div class="msg-content-left" v-if="msg.messageType=='留言'|| msg.messageType=='建议'">-->
                <!--您的<span>{{'    “'+formatText(msg.title)+'”    '}}</span> {{`${msg.messageType}，有新的回复。`}}-->
              <!--</div>-->
              <!--<div class="msg-content-left" v-else-if="msg.messageType=='通知公告'">-->
                <!--通知公告<span>{{'    “'+formatText(msg.title,10)+'”'}}</span>。-->
              <!--</div>-->
              <div class="msg-content-left" @click="seeDetailFn(msg)">
                <div v-if="msg.msgType == '21'" v-html="msg.title"></div>
                <div v-else>{{msg.title}}</div>
                <div>
                  {{setMsgName(msg.msgType)}} &nbsp &nbsp {{msg.createTime}}
                  <span v-if="msg.msgType == '96'">{{msg.ext4 == 'end'  ? '正常完结' : '中断'}} {{msg.source == '01' ? '已完结' : '未完成'}}</span>
                </div>
              </div>
              <div class="msg-content-right">
                <!--<span v-if="msg.msgType==1&&msg.readFlag=='未读'" @click="getBpmnNoticeVisitUrl(msg)">查看详情</span>-->
                <span :class="msg.readFlag == '0' ? 'noClass' : ''"  v-if="msg.readFlag == '0'" @click="readClick(msg)">未读</span>
                <span  v-if="msg.readFlag == '1'">已读</span>
                <!--<span  v-if="msg.messageType=='留言'|| msg.messageType=='建议'" @click="seeDetailFn(msg)">查看详情</span>-->
                <!--<span  v-if="msg.messageType=='通知公告'" @click="notyDetailFn(msg)">查看详情</span>-->
              </div>
            </div>

          </div>

        </div>
      </div>
      <div class="clickMore" v-if="list.length!=0&&list.length<total"><span @click="clickMore">点击加载更多</span></div>
      <div  v-else-if="list.length==0&&list.length==total"  class="clickMore"><span>无消息通知</span></div>
      <div class="clickMore" v-else><span>没有更多了</span></div>
    </div>
  </div>
</template>

<script>
    import Sift from "@/components/sift/Sift";
    import {
        bpmnPageBpmnNotice,
        bpmnNoticeVisitUrl,
        setUserRead,
        setUserAllRead
    } from '@/api/bpmnApi/bpmn';
    import { remote } from '@/api/admin/dict';
    import { mapActions } from "vuex";
    export default {
        name: "Message",
        components: {
            Sift,
        },
        props: [],
        data() {
            return {
                loading: false,
                siftData: [],
                paramSearch:{
                    current:1,
                    size:6,
                    messageType:''
                },
                messageTypeList:[],
                list: [],
                total:0
            };
        },
        computed: {
            msglist(){
                let arr=[];
                let year=[];
                let yearMonth=[];
                this.list.forEach((item,index )=>{
                    let splitArr =  item.createTime.split('-');
                    let itemYear=splitArr[0];
                    let itemYearMonth=splitArr[0]+'-'+splitArr[1];
                    let itemYearStr='';
                    let itemYearMonthstr='';
                    if(!year.includes(itemYear)){
                        itemYearStr=itemYear;
                        year.push(itemYear)
                        if(!yearMonth.includes(itemYearMonth)){
                            itemYearMonthstr=itemYearMonth;
                            yearMonth.push(itemYearMonth);
                            arr.push({...item,year:itemYearStr,yearMonth:itemYearMonthstr});
                        }else{
                            arr.push({...item,year:itemYearStr,yearMonth:itemYearMonthstr});
                        }
                    }else{
                        if(!yearMonth.includes(itemYearMonth)){
                            itemYearMonthstr=itemYearMonth;
                            yearMonth.push(itemYearMonth);
                            arr.push({...item,year:itemYearStr,yearMonth:itemYearMonthstr});
                        }else{
                            arr.push({...item,year:itemYearStr,yearMonth:itemYearMonthstr});
                        }
                    }

                })
                return arr;
            },
            setMsgName(){
                return function (val) {
                    let name = ''
                        this.messageTypeList.forEach((o) =>{
                            if(o.value == val) {
                                name =  o.label
                            }
                        })
                        return name
                }
            },
            getStatus(){
                let blo = this.list.findIndex(item => item.readFlag == '0') > -1 ? true : false
                return blo
            }
        },
        created(){
            this.remoteFn();
        },
        mounted() {
        },
        methods: {
            ...mapActions(["GetUnreadCount"]),
            clickMore(){
                this.paramSearch.current++;
                this.getBpmnPageBpmnNotice();
            },
            initList(){
                this.paramSearch.current=1;
                this.list=[];
                this.getBpmnPageBpmnNotice();
            },
            seeDetailFn(msg){
                console.log(msg);
                if(msg.messageType=='90'){
                    this.$router.push({path:'/mine/suggest'})
                    return;
                }
                if(msg.messageType=='98'){
                    this.$router.push({path:'/mine/voiceMessage'})
                }
                if(msg.msgType=='93' && msg.content.indexOf('http') > -1){
                    this.readClick(msg)
                    window.open(msg.content)
                }
                if((msg.msgType=='21' || msg.msgType=='23' || msg.msgType=='20') && msg.content.indexOf('http') > -1){
                    this.readClick(msg)
                    window.open(msg.content)
                }
            },
            getBpmnNoticeVisitUrl(msg){
                let params={
                    taskId:msg.taskId,
                    instId:msg.instId
                };
                bpmnNoticeVisitUrl(params).then(({data})=>{

                    if(data.code==0){
                        this.GetUnreadCount();
                        window.open(data.data)

                    }else{
                        this.$message.warning(data.msg);

                    }
                }).catch(err=>{

                })
            },

            getBpmnPageBpmnNotice(){
                this.loading =true ;
                bpmnPageBpmnNotice(this.paramSearch).then(({data})=>{
                    this.loading =false;
                    if(data.code==0){
                        let Arr=(data.data.records||[]).map(item=>{
                            return {...item,msgType:item.type}
                        })
                        this.list =[...this.list,...Arr];

                        this.total= data.data.total
                    }else{
                        this.$message.warning(data.msg||'获取消息失败');

                    }
                }).catch(err=>{
                    this.loading =false;
                })
            },
            //获取类型
            remoteFn(){
                remote('message_type').then(({data})=>{
                    if(data.code == 0){
                        this.messageTypeList = data.data||[];
                        if(this.messageTypeList.length){
                            this.paramSearch.messageType= this.messageTypeList[0].value;
                        }

                    }else{
                        this.$message.warning( data.msg|| "获取类型失败!" );
                    }
                }).catch(err=>{
                    this.$message.error( data.msg|| "获取类型异常!" );
                })

            },
            notyDetailFn(msg){
                let routeData = this.$router.resolve({
                    name: '/notifyDetail',
                    query: {
                        id: msg.id
                    }
                });
                window.open(routeData.href);
            },
            formatText(title, length){
                let num=length||10;
                let titleStr=title || ""
                if(titleStr.length>num){
                    titleStr=titleStr.substring(0,10)+'...';
                }
                return titleStr;
            },
            // 单条标记已读
            readClick(msg){
                let params = {
                   id: msg.id || '',
                   type: msg.type || '',
                   userId:  this.$store.getters.userData.userId || ''
                }
                setUserRead(params).then(({data}) =>{
                    if(data.code == 0){
                        this.$message.success(  "标记已读成功!" );
                        this.list =  []
                        this.getBpmnPageBpmnNotice()
                    }else {
                        this.$message.warning(data.msg||'标记已读失败');
                    }
                }).catch(err=>{
                    this.$message.error( data.msg|| "标记已读异常!" );
                })
            },
            //全部标记已读
            setAllread(){
                let params = {
                    userId:  this.$store.getters.userData.userId || ''
                }
                this.$confirm('确认全部标记为已读?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    setUserAllRead(params).then(({data}) =>{
                        if(data.code == 0){
                            this.$message.success(  "标记已读成功!" );
                            this.list =  []
                            this.getBpmnPageBpmnNotice()
                        }else {
                            this.$message.warning(data.msg||'标记已读失败');
                        }
                    }).catch(err=>{
                        this.$message.error( data.msg|| "标记已读异常!" );
                    })
                })
            }
        },
        watch: {
            'paramSearch.messageType'(){
                this.initList();
                // this.remoteFn()
            }
        },
        filters: {}
    };
</script>

<style scoped lang="less">
  .message-warp{
    padding-top: 50px;
  }
  .msg-item{}
  .msg-left{
    width: 150px;
    min-height: 10px;
    font-weight: bold;
    padding-top: 10px;
    text-align: right;
    padding-right: 30px;
    font-size: 24px;
    color: #6E747D;
  }
  .msg-right{
    width: calc(100% - 200px);
    border-left: 1px dashed #ccc;
    min-height: 50px;
    padding-top: 15px;
    position: relative;
    >.month{
      display: block;
      position: relative;
      top: -22px;
      height: 30px;
      line-height: 30px;
      padding-left: 20px;
      font-weight: bold;
      font-size: 18px;
      color: #5F6368;
    }
  }
  .msg-content:before{
    content: "";
    width: 14px;
    height: 14px;
    border-radius: 7px;
    border: 1px solid #56ABE4;
    display: inline-block;
    background: #fff;
    box-sizing: border-box;
    margin-left: -43px;
    float: left;
    box-shadow: 0 2px 4px rgba(86, 171, 228, .42), 0 0 6px rgba(86, 171, 228, .24);
  }
  .el-icon-location{
    color: #56ABE4;
    font-size: 36px;
    position: absolute;
    top: -30px;
    left: -19px;

  }
  .msg-content{
    background: #F5F5F5;
    padding: 20px 15px;
    margin-left: 20px;

    position: relative;
    top: -20px;

    &-left{
      width: calc(100% - 110px);
      float: left;
      color: #666666;
      font-size: 13px;
      line-height: 24px;
      min-height: 28px;
      line-height: 28px;
      cursor: pointer;
    }
    &-right{
      width: 100px;
      float: right;
      text-align: right;
      >span{
        display: inline-block;
        padding: 0 10px;
        height: 28px;
        background: #EDEDED;
        border: 1px solid #ADADAD;
        border-radius: 3px;
        text-align: center;
        color: #6D6D6D;
        line-height: 28px;
        cursor: pointer;
        &.is-ready{
          cursor:default;
          border: 1px solid #ADADAD;
          color: #ADADAD;
          background: transparent;
        }
      }
      .noClass{
        background-color: #FFFFFF;
        border: 1px solid #49A4F0;
        color: #49A4F0;
      }
    }
  }
  .clickMore{
    text-align: center;
    padding-top: 10px;
    >span{
      color: #ccc;
      cursor: pointer;
    }
  }
</style>
